import {
  AsesorChargeApi,
  PoliticSpaceApi,
} from "../../../../Shared/Constants/api";

import axiosInstance from "../../../../Shared/Utils/axiosInstance";

import { getPoliticSpaceCreationObject } from "../Data/PoliticSpaceWrappers";

export const updatePoliticSpaceApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${PoliticSpaceApi}/${id}`,
      getPoliticSpaceCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further PoliticSpace if needed
  }
};
